var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("img", {
      staticClass: "imgCenter",
      attrs: { src: require("assets/pcTitle2.png"), alt: "" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "block1" }, [
        _c("div", { staticClass: "itemBox" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "zjBox" },
            _vm._l(_vm.doctorList, function(item, index) {
              return _c("div", { key: index, staticClass: "zjItemBox" }, [
                _c("img", {
                  attrs: { src: _vm.EnvUrl + item.doctorWorkPhoto, alt: "" }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "zjName" }, [
                    _vm._v(_vm._s(item.doctorName))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "doctorProfile" }, [
                    _vm._v(_vm._s(item.doctorProfile))
                  ])
                ])
              ])
            })
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "personnelBox" },
            _vm._l(_vm.doctorMap, function(item, index) {
              return _c("div", { key: index, staticClass: "personnelItem" }, [
                _c("div", { staticClass: "personnelName" }, [
                  _vm._v(_vm._s(item.name))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "personnelValue" }, [
                  _vm._v(_vm._s(item.value))
                ])
              ])
            })
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "courseBox" },
            _vm._l(_vm.offlineCourseList, function(item, index) {
              return _c("div", { key: index, staticClass: "courseItem" }, [
                _vm._v("\n            " + _vm._s(item.date) + "\n            "),
                _c("div", { staticClass: "courseIndex" }, [
                  _vm._v(_vm._s(index + 1))
                ]),
                _vm._v("\n            " + _vm._s(item.text) + "\n          ")
              ])
            })
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block2" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "jjqkBox" }, [
            _c("div", { staticClass: "jjLine" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "jjBox" },
              _vm._l(_vm.userTestLevelList1, function(item, index) {
                return _c("div", { key: index, staticClass: "jjItem" }, [
                  _vm._v(
                    "\n              " + _vm._s(item.level) + "\n              "
                  ),
                  _c("div", { staticClass: "jjNum" }, [
                    _vm._v(_vm._s(item.testCount))
                  ])
                ])
              })
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "jjqkBox" }, [
            _c("div", { staticClass: "jjLine" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "jjBox" },
              _vm._l(_vm.userTestLevelList2, function(item, index) {
                return _c("div", { key: index, staticClass: "jjItem" }, [
                  _vm._v(
                    "\n              " + _vm._s(item.level) + "\n              "
                  ),
                  _c("div", { staticClass: "jjNum" }, [
                    _vm._v(_vm._s(item.testCount))
                  ])
                ])
              })
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block3" }, [
        _c("div", { staticClass: "itemBox" }, [
          _vm._m(6),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "genderBox" },
            _vm._l(_vm.activeList, function(item, index) {
              return _c("div", { key: index, staticClass: "zyzword" }, [
                _vm._v(_vm._s(index + 1) + "." + _vm._s(item.name))
              ])
            })
          )
        ]),
        _vm._v(" "),
        _vm._m(7),
        _vm._v(" "),
        _vm._m(8)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _c("div", { staticClass: "titleWord" }, [_vm._v("业务协同")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _c("div", { staticClass: "titleWord" }, [_vm._v("专家库人员")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _c("div", { staticClass: "titleWord" }, [_vm._v("线下课程")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "itemBox" }, [
      _c("div", { staticClass: "titleBox" }, [
        _c("div", { staticClass: "titleWord" }, [_vm._v("联防联控")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "canvasBox" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _c("div", { staticClass: "titleWord" }, [_vm._v("家境情况分布")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _c("div", { staticClass: "titleWord" }, [_vm._v("犯罪认知度")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _c("div", { staticClass: "titleWord" }, [_vm._v("志愿者活动")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "itemBox" }, [
      _c("div", { staticClass: "titleBox" }, [
        _c("div", { staticClass: "titleWord" }, [_vm._v("不良心理潜在原因")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qsBox" }, [
        _c("div", { attrs: { id: "myChart1" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "itemBox" }, [
      _c("div", { staticClass: "titleBox" }, [
        _c("div", { staticClass: "titleWord" }, [_vm._v("就业信息")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qsBox" }, [
        _c("div", { attrs: { id: "myChart2" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e297f35", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e297f35","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/pcData2.vue
// module id = null
// module chunks = 